import React from 'react'

import history from '../router/history'

export default {
    
    toWelcome(e) {
        history.push("/welcome");
    },
    
    toLogin(e){
        history.push("/login");
    },
    
    toPortal(e){
        history.push("/portal");
    },
    
    toSignUp(e){
        history.push("/register");
    }
    
};


/** WEBPACK FOOTER **
 ** ./src/app/router/links.js
 **/